<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-07 09:19:50
 * @LastEditors: luckymiaow
 * @LastEditTime: 2022-12-30 17:08:39
-->

<script lang="ts" setup>
import { onMounted, reactive, ref, unref, useAttrs, useSlots, watch, withDefaults } from 'vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import SelectBasic from '../../select/src/_SelectBasic.vue';
import type { ApiPaged, IPaged, IPagedEnumerable, ISelectPagedProps } from '../types';
import useForm from '../../form/src/useFormConfig';

import type { FieldNames } from '../../select/types';

interface IProps extends ISelectPagedProps {
  api: ApiPaged;

  params?: object | null; // 接口参数 此属性改变时会自动重新加载接口数据

  fieldNames?: FieldNames;

  limit?: number; // 每次请求多少条数据

  immediate?: boolean; // 是否立即加载数据 默认false

  nullValue?: any; // 指定数据为null
}

const props = withDefaults(defineProps<IProps>(), {
  limit: 10,
  immediate: false,
});

const { getBindValue } = useForm<IProps>({ props, componentName: 'SelectPaged', attrs: useAttrs() });

const value = ref();

const optionsResult: IPagedEnumerable<unknown> = reactive({ limit: 0, offset: 0, totals: null, items: [] });

const isFirstLoad = ref(true);

const loading = ref(false);

const currentPage = ref(1);

const paged = ref<IPaged>({ limit: 10, offset: 0 });

watch(
  () => props?.params,
  () => {
    optionsResult.items = [];
    paged.value.limit = (props.params as any)!.limit ?? 10;
    paged.value.offset = (props.params as any)!.offset ?? 0;
    !unref(isFirstLoad) && fetchData();
  }
);

watch(
  () => getBindValue.value.value,
  () => {
    if (props.nullValue === getBindValue.value.value) {
      value.value = undefined;
    } else {
      value.value = getBindValue.value.value;
    }
  },
  { immediate: true }
);

const slots = useSlots();

async function fetchData() {
  if (!props?.api || getBindValue.value?.options || 'default' in slots) return;
  if (optionsResult.totals !== 0 && optionsResult.items?.length === optionsResult.totals) return;

  try {
    loading.value = true;

    const temp = { ...unref(props.params), ...paged.value };

    const res = await props.api(temp);
    optionsResult.offset = res.offset;
    optionsResult.limit = res.limit;
    optionsResult.totals = res.totals;
    optionsResult.items = optionsResult.items!.concat(res.items);
  } catch (error) {
    console.warn(error);
  } finally {
    loading.value = false;
  }
}

async function dropdownVisibleChange() {
  if (unref(isFirstLoad)) {
    paged.value.limit = props.limit;
    await fetchData();
    isFirstLoad.value = false;
  }
}

async function popupScroll(e: any) {
  if (props.params === null) return;
  const { scrollTop, offsetHeight, scrollHeight } = e.target;
  if (Math.ceil(scrollTop + offsetHeight) >= scrollHeight) {
    paged.value.offset = currentPage.value * paged.value.limit;
    await fetchData();
    currentPage.value =
      optionsResult.items!.length / paged.value.limit >= 1
        ? Math.ceil(optionsResult.items!.length / paged.value.limit)
        : 1;
  }
}

onMounted(() => {
  if (props.immediate) {
    dropdownVisibleChange();
  }
});
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <SelectBasic
    v-bind="getBindValue"
    v-model:value="value"
    :options="optionsResult.items"
    @dropdownVisibleChange="dropdownVisibleChange"
    @popupScroll="popupScroll"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template v-if="loading" #suffixIcon>
      <LoadingOutlined spin />
    </template>
  </SelectBasic>
</template>
